import { useMemo } from 'react';
import { rage, useObservable } from '~/rage';
import { characterSkillByJob, Job } from '~/shared';

const usePlayerLevel = (jobId?: Job) => {
	const openedJobId = useObservable(rage.jobs.getOpenedJobId());
	const currentJobId = useMemo(
		() => jobId ?? openedJobId ?? Job.Farmer,
		[jobId, openedJobId],
	);

	const skillId = useMemo(
		() => characterSkillByJob[currentJobId],
		[currentJobId],
	);

	const {
		level: playerLevel,
		maxLevel: playerMaxLevel,
		...rest
	} = useObservable(rage.skills.getSkillLevel(skillId));

	return { playerLevel, playerMaxLevel, ...rest };
};

export { usePlayerLevel };
